export default __webpack_public_path__ + "static/media/LUMYS-logo-couleurs.e324194a.png";